<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <label>CUSTO</label>
        <b-input type="text" v-model="cost" @keyup="handleCost" />
      </div>
      <div class="col-md-4">
        <label>LUCRO(%)</label>
        <b-input type="text" v-model="profit" v-on:keyup="handleProfit" />
      </div>
      <div class="col-md-4">
        <label>VALOR DA VENDA</label>
        <b-input type="text" v-model="sale" v-on:keyup="handleSale" />
      </div>
      <div class="col-md-12"><errors-messages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <v-btn-save
          :disabled="loading"
          :loading="loading"
          type="button"
          @click="execute"
          class="ml-2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";
import VBtnSave from "../../../../Components/VBtnSave";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
} from "../../../../../lib/format";

export default {
  name: "EditItemValue",

  components: {
    ErrorsMessages,
    VBtnSave,
  },

  data() {
    return {
      cost: "",
      profit: "",
      sale: "",

      loading: false,
      errors: [],
    };
  },

  props: {
    stock_item_id: { type: [Number, String, Boolean] },
  },

  methods: {
    formatPrice,
    formatValueOnKeyUp,
    formatValueToOnlyNumber,
    formatValueToPercentage,

    handleProfit(e) {
      let profit = formatValueToPercentage(e.target.value);
      if (profit) {
        let current = formatValueToOnlyNumber(this.cost);
        let percentage = profit * current;
        let sale = percentage / 100;
        sale = parseFloat(sale) + parseFloat(current);
        this.sale = formatPrice(sale);
      } else {
        this.sale = formatPrice(0);
      }
    },

    handleCost(e) {
      this.cost = formatValueOnKeyUp(e.target.value);

      let { profit, cost } = this;

      if (profit) {
        let current = formatValueToOnlyNumber(cost);
        let percentage = profit * current;
        let sale = percentage / 100;
        sale = parseFloat(sale) + parseFloat(current);
        this.sale = formatPrice(sale);
      } else {
        this.sale = formatPrice(0);
      }
    },

    handleSale(e) {
      let sale = formatValueToOnlyNumber(e.target.value);

      this.sale = formatValueOnKeyUp(sale);

      let { cost } = this;

      cost = formatValueToOnlyNumber(cost);

      if (parseFloat(sale) > parseFloat(cost)) {
        let profit = parseFloat(sale) - parseFloat(cost);
        profit = parseFloat(profit) / parseFloat(cost);
        profit = parseFloat(profit) * 100;
        if (String(profit).indexOf(".") > -1) {
          profit = profit.toFixed(2);
        }
        this.profit = profit;
      } else {
        this.profit = 0;
      }
    },

    async execute() {
      try {
        this.loading = true;

        let { stock_item_id, cost, profit, sale } = this;

        const data = { stock_item_id, cost, profit, sale };

        const response = await api.patch(
          "/rest-home/stock/items/cost-profit-sale",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("success");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
